import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";

import { Doughnut } from "react-chartjs-2";
import {
    Button,
    Block,
    BlockDes,
    BlockHead,
    Icon,
    Col,
    Row,
    PreviewAltCard,
} from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import OptionC from "../../components/DynmicOption/OptionC";
import AdminUserDataUpdate from "./AdminUserDataUpdate";
import FinancialYear from "../../components/DynmicOption/FinancialYear";


const UserDetailsRegular = ({ ...props }) => {
    const [isShown, setIsShown] = useState(false);
    const [transData, setTransData] = useState([]);
    const [monthdata, setmonthdata] = useState([]);
    const [onSearchText, setSearchText] = useState("");
    const month1 = ["Test","JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [modal, setModal] = useState({
        add: false,
    });
    const today = new Date();
    const [lorder, setLorder] = useState(true);
    const [data, setData] = useState(transData);
    const [formData, setFormData] = useState({
        month: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() === 0 ? 12 : today.getMonth(): sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? today.getMonth() === 0 ? today.getFullYear() - 1 :today.getFullYear(): sessionStorage.getItem("CurrentYear"),
        fromyear: sessionStorage.getItem("CurrentFinancialYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentFinancialYear"),
        EmploymentRefId: 0,
        //toyear: sessionStorage.getItem("CurrentFinancialYearto") === null ? today.getFullYear(): sessionStorage.getItem("CurrentFinancialYearto"),
        toyear: sessionStorage.getItem("CurrentFinancialYearTosame") === null ? today.getFullYear() + 1 : sessionStorage.getItem("CurrentFinancialYearTosame"),

    });
    const [userData, setuserData] = useState(null);
    const [data2, setData2] = useState({
        labels: ["Deaft", "Submitted"],
        dataUnit: "People",
        legend: false,
        datasets: [
            {
                borderColor: "#fff",
                backgroundColor: ["#f9db7b", "#1ee0ac",  ],
                data: [2, 1],
            },
        ],
    })
    const tableRef = useRef(null);
    const getdata = async () => {
        const sendData = {
        
            EmploymentRefId: Number(formData.EmploymentRefId),
        }
        await fetch(process.env.REACT_APP_API_LINK+'api/Main/GetparametersNumber', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setData(data)
                    ////console.log(data)
                    setLorder(false)
                })
 

    };

    const getdatadash = async () => {
        const sendData = {

            UserId: Number(localStorage.getItem("userId")),
            Apikey1: String(Number(formData.toyear) - 1),
            Apikey2: String(formData.toyear)
        }
        ////console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/DashboardData', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setmonthdata(data)
                    ////console.log(data)
                    const edit = data.filter(a => a.activeStatus === "A")
                    const sub = data.filter(a => a.activeStatus === "S")
                   
                    setData2({
                        labels: ["Draft", "Submitted"],
                        dataUnit: "People",
                        legend: false,
                        datasets: [
                            {
                                borderColor: "#fff",
                                backgroundColor: ["#f9db7b", "#1ee0ac",],
                                data: [edit.length, sub.length],
                            },
                        ],
                    })

           
                })


    };
    const usergetdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
        }

        await fetch(process.env.REACT_APP_API_LINK+'api/Payment/Getuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setuserData(data)
                    ////console.log(data)
                })


    };


    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });
   
    };
   /* const onInputChange3 = (month, year) => {
        setFormData({ ...formData, year: year });

    };*/
    const onInputChange3 = (e) => {
        setFormData({ ...formData, year: e.target.value, toyear: Number(e.target.value)+1 });
        sessionStorage.setItem("CurrentFinancialYear", e.target.value);
        sessionStorage.setItem("CurrentFinancialYearTosame", Number(e.target.value) + 1);  

    };
    const onInputChange2 = (tomonth, toyear) => {
        setFormData({ ...formData, toyear: toyear });

    }     
    // Changing state value when searching name
    useEffect(() => {
        if (onSearchText !== "") {
            const filteredObject = transData.filter((item) => {

                return item.organizationName.toLowerCase().includes(onSearchText.toLowerCase()) || item.phoneNo.toLowerCase().includes(onSearchText.toLowerCase()) || item.emailId.toLowerCase().includes(onSearchText.toLowerCase());
            });
            setData([...filteredObject]);
        }
        else {
            setData([...transData]);
        }

    }, [onSearchText]);


    useEffect(() => {
        getdatadash()
        getdata()
        usergetdata()
    }, [formData.year, formData.toyear])

    
    // function to reset the form
    const resetForm = () => {
        setFormData({
            organization: "",
            desiganationyear: "",
            designation: "",
        });
    };

   

    const openSubmit = async (employmentId) => {

        Swal.fire({
            title: 'Are You Sure you want to Recheck?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }
                await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Openform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                getdatadash()
                                getdata()
                                usergetdata()
                            } else {
                                Swal.fire({
                                    title: 'Data Not Updated',
                                    icon: 'error',
                                })
                            }
                        })
            } else if (result.isDenied) {
                getdata()

            }
        })
    };

    
    const viewpage = async (employmentId) => {

        sessionStorage.setItem("employmentId",employmentId)
        sessionStorage.setItem("EmploymentRefId", 10)
        window.location.href = "/NCSCDA-View?data=5"
    };
    const editpage = async (employmentId) => {

        sessionStorage.setItem("employmentId",employmentId)
        sessionStorage.setItem("EmploymentRefId", 10)
        window.location.href = "/NCSCDA-Edit?data=5"
    };


   
    return (
        <React.Fragment>
            <Head title="AllUser" />
            
            <Content>
               

                <Block>
                    
                    <BlockHead size="lg">
                        {localStorage.getItem("urole") === "7" ? <Button color="dark" style={{ marginBottom: 20 }} onClick={() => window.location.href = '/Admin-Dashboard'}><Icon name="arrow-left" /> Back Admin Dashboard </Button> : null}
                            <BlockDes className="text-soft">
                            
                                <Row >
                                {localStorage.getItem('urole') === "7" ? <>
                                    <Col xl="4" md="4">
                                        <td >
                                            <h5 style={{ color: '#798bff' }}>User Dashboard</h5>
                                        </td>
                                    </Col>
                                    <Col xl="4" md="4" >

                                        <label style={{ color: 'black', fontSize: 15 }}>  Center :  <label style={{ fontWeight: 'bold' }}> {userData != null ? userData.state : null}</label></label>
                                    </Col></> :<> <Col xl="3" md="3">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>User Dashboard</h5>
                                        </td>
                                    </Col>  <Col xl="3" md="3" >

                                    <label style={{ color: 'black',  fontSize: 15 }}>  Center :  <label style={{ fontWeight: 'bold' }}> {userData != null ? userData.state : null}</label></label>
                                </Col></>}
                                {localStorage.getItem('urole') === "7" ? null :<>
                                <Col xl="3" md="3" >
                            
                                    <label style={{ color: 'black', fontSize: 15 }}>  <label style={{ fontWeight: 'bold' }}><OptionC defaultValuemain={formData.year} catid="42" onInputChange={onInputChange} namemain="year" mainid="year" /></label></label>
                                        


                                    </Col>
                                   
                                   <Col xl="3" md="3" >
                                       
                                    <AdminUserDataUpdate name={'NSCDA'} month={formData.month} path={'/NCSCDA?data=5'} path2={'/NCSCDA-View?data=5'} year={formData.year} parent={10} AdminUserDataUpdate={AdminUserDataUpdate} />
                                   
                                    </Col></>}
                            </Row>
                            <hr />
                            <Row>
                                <Col md="4" xxl="4">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <h6 className="ff-base fw-medium"><b style={{ fontSize: 20 }}>  Summary</b> :<br /><br /> <small className="text-soft">The User Dashboard Shows The  Statements of physical progress of NCSC-DA s
                                          
                                        </small></h6>
                                    </PreviewAltCard>
                                </Col>
                                <Col md="8" xxl="8">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <Row>
                                            <Col md="2"></Col>
                                            <Col md="6">
                                            <div className="traffic-channel-group">
                                            
                                                <div >
                                                    <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                                                            <b style={{ fontSize: 20 }}> Draft : <large style={{ marginLeft: 80 }}> {data2.datasets[0].data[0]}</large> </b>
                                                    </div>
                                                    <div className="amount">
                                                        
                                                    </div>
                                                    </div>
                                                 
                                                <div >
                                                    <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                                                            <b style={{ fontSize: 20 }}> Submitted : <large style={{ marginLeft: 32 }}> {data2.datasets[0].data[1]}</large></b>
                                                    </div>
                                                    <div className="amount">
                                                        
                                                    </div>
                                                </div>
                                                <div >
                                                    <div className="title">
                                                       </div>
                                                    <div className="amount">
                                                        
                                                    </div>
                                                </div>
                                                
                                                </div>
                                            </Col>
                                           <Col md="4">
                                            <div className="traffic-channel-doughnut-ck">
                                                <Doughnut
                                                    className="analytics-doughnut"
                                                    data={data2}
                                                    options={{
                                                        legend: {
                                                            display: false,
                                                        },
                                                        rotation: -1.5,
                                                        cutoutPercentage: 70,
                                                        maintainAspectRatio: false,
                                                        tooltips: {
                                                            enabled: true,
                                                            backgroundColor: "#fff",
                                                            borderColor: "#eff6ff",
                                                            borderWidth: 2,
                                                            titleFontSize: 13,
                                                            titleFontColor: "#6783b8",
                                                            titleMarginBottom: 6,
                                                            bodyFontColor: "#9eaecf",
                                                            bodyFontSize: 12,
                                                            bodySpacing: 4,
                                                            yPadding: 10,
                                                            xPadding: 10,
                                                            footerMarginTop: 0,
                                                            displayColors: false,
                                                        },
                                                    }}
                                                ></Doughnut>
                                            </div>
                                              
                                            </Col>
                                        </Row>
                                    </PreviewAltCard>
                                    
                                </Col>
                            </Row>

                            <div className="table-responsive">
                                <table className="table table-orders" ref={tableRef}>
                                    <thead className="tb-odr-head">
                                        <tr className="tb-odr-item" >
                                        <th></th>
                                        <th></th>
                                          
                                            
                                        </tr>


                                    </thead>
                                    <>
                                        <Row >
                                           
                                            <Col xl="6" md="6">
                                                <td >
                                                    <h5 style={{ color: '#798bff', marginTop: "15px", fontWeight: "bold" }}> Financial Year Filter</h5>
                                                </td>
                                            </Col>
                                            <Col xl="6" md="6" >
                                                <label style={{ color: 'black', fontSize: 12, marginTop: "15px" }}>  <label style={{ fontWeight: 'bold' }}><FinancialYear defaultValuemain={`${Number(formData.toyear) - 1}-${formData.toyear}`} catid="42" onInputChange={onInputChange3} namemain="year" mainid="year" /></label></label>


                                            </Col>
                                           {/* <Col xl="4" md="4" >
                                                <label style={{ color: 'black', fontSize: 13, marginTop: "15px" }}> <label style={{ fontWeight: 'bold' }}><FinancialYearTo defaultValuemain={formData.toyear} year={formData.toyear} fromyear={Number(formData.year) + 1} onInputChange={onInputChange2} month={formData.month} /></label></label>


                                            </Col>*/}
                                         

                                        </Row>
                                    </>
                                </table>
                                
                            </div>

                            </BlockDes>

                       
                        </BlockHead>
                        

                    <div className="table-responsive" style={{ marginTop:-70 }}>
                        <table className="table table-orders" ref={tableRef}>
                            <thead className="tb-odr-head">
                                <tr className="tb-odr-item" >
                                            <th >
                                                S.No

                                            </th>
                                            <th >
                                              Month

                                            </th>
                                            <th  >
                                              Year

                                            </th>
                                            <th >
                                                Status

                                            </th>  
                                             <th >
                                                Action

                                    </th>
                                    {localStorage.getItem("urole") === "7" ? <th >
                                        Send To Recheck

                                    </th> : null}
                                        </tr>
                                    

                            </thead>   

                            <tbody>
                                {monthdata.length === 0 ? null : monthdata.map((datamain, index) =>
                                (datamain.activeStatus === "D" ? null :
                                    <tr key={index} className="tb-odr-item" >

                                        <td  >
                                            <a
                                                href="#id"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                            >
                                                <b style={{ fontSize: 18 }}>{index + 1}</b>
                                            </a>
                                        </td>

                                        <td  >
                                            <a
                                                href="#id"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                            >
                                                <b style={{ fontSize: 18 }}>{month1[datamain.monthId]}</b>
                                            </a>
                                        </td>
                                        <td  >
                                            <a
                                                href="#id"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                            >
                                                <b style={{ fontSize: 18 }}>{datamain.yearId}</b>
                                            </a>
                                        </td>
                                        <td  >
                                            {datamain.activeStatus === "A" ? <> <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>  <b style={{ fontSize: 18 }}>  Draft</b></> : datamain.activeStatus === "S" ? <> <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>  <b style={{ fontSize: 18 }}> Submitted</b></> : null}
                                        </td>

                                        {localStorage.getItem('urole') === "7" ? <td  >
                                            {datamain.activeStatus === "A" ? <Button onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)} style={{ backgroundColor: "#f9db7b", color: "white", borderColor: "white" }} >
                                                <b style={{ fontSize: 18 }}>{!isShown ? "Edit" : null}  {isShown && (
                                                    <div>
                                                        You cannot Edit this page.
                                                    </div>
                                                )} <em className="icon ni ni-pen2"></em></b>
                                            </Button> : datamain.activeStatus === "S" ? <Button
                                                color="success" onClick={(ev) => {
                                                    ev.preventDefault();
                                                    viewpage(datamain.employmentId)
                                                }} >
                                                <b style={{ fontSize: 18 }}>View <em className="icon ni ni-eye-fill"></em></b>
                                            </Button> : null}

                                        </td> : <td  >
                                            {datamain.activeStatus === "A" ? <Button onClick={(ev) => {
                                                ev.preventDefault();
                                                editpage(datamain.employmentId);
                                            }} style={{ backgroundColor: "#f9db7b", color: "white", borderColor: "white" }} >
                                                <b style={{ fontSize: 18 }}> Edit <em className="icon ni ni-pen2"></em></b>
                                            </Button> : datamain.activeStatus === "S" ? <Button
                                                color="success" onClick={(ev) => {
                                                    ev.preventDefault();
                                                    viewpage(datamain.employmentId)
                                                }} >
                                                <b style={{ fontSize: 18 }}>View <em className="icon ni ni-eye-fill"></em></b>
                                            </Button> : null}

                                        </td>}

                                        {localStorage.getItem("urole") === "7" ? <td  >
                                            {datamain.activeStatus === "A" ? <Button style={{ backgroundColor: "#f9db7b", color: "white", borderColor: "white" }} >
                                                <b style={{ fontSize: 18 }}> Not Submitted <em className="icon ni ni-files-fill"></em> </b>
                                            </Button> : datamain.activeStatus === "S" ? <Button
                                                color="success" onClick={(ev) => {
                                                    ev.preventDefault();
                                                    openSubmit(datamain.employmentId)
                                                }} >
                                                <b style={{ fontSize: 18 }}>Recheck <em className="icon ni ni-edit"></em></b>
                                            </Button> : null}

                                        </td> : null}


                                    </tr>
                                ))}
                                
                            </tbody>          
                                                   
                                          
                                       
                                            

                                </table>
                        {monthdata.length === 0 ?<center><h4>No Data Found</h4> </center>    :

                            null}
                            </div>


                        
                    
                </Block>

                
                    
                
            </Content>
            
        </React.Fragment>
    );
};

export default UserDetailsRegular;
